import script from "./ScrollThumbBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollThumbBlock.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollThumbBlock.vue?vue&type=style&index=0&id=d47ca554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d47ca554"]])

export default __exports__